const multipleData = {
  '检验检测': {
    // 'active': true,
    '条件': [
      // {
      //   name: '待定1',
      //   id: '已作废'
      // },
      // {
      //   name: '待定2',
      //   id: '现行有效'
      // }
    ]
  }
}
export default multipleData



// WEBPACK FOOTER //
// ./src/layout/common/config/test.js